import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";

import VehicleDetails from "../views/Company/VehicleDetails";
import CustomerDashboardPage from "./dashboard";
// import NewDashboard from "./newDashboard";

class DashboardRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/dashboard" component={CustomerDashboardPage} />
        {/* <Route exact path="/dashboard/new" component={NewDashboard} /> */}
        <Route
          exact
          path="/dashboard/vehicle/:vId"
          component={VehicleDetails}
        />
      </Switch>
    );
  }
}

export default DashboardRoutes;



// WEBPACK FOOTER //
// ./src/customers/DashboardRoutes.js